import { AuthenticatedTemplate } from "@azure/msal-react";
import { Outlet, useNavigate } from "react-router";
import { useAuthentication } from "../../authConfig";
import { useEffect } from "react";

type ProtectedRouteProps = {
    roles?: string[] | string;
    redirectPath?: string;
};

export function ProtectedRoute({ roles, redirectPath }: ProtectedRouteProps) {
    const { hasSomeRoles } = useAuthentication();
    const navigate = useNavigate();
    useEffect(() => {
        if (roles && !hasSomeRoles(roles)) {
            navigate(redirectPath ? redirectPath : "/");
        }
    }, [roles]);
    return <Outlet />;
}
